module.exports = __webpack_public_path__ + "img/image-14.bc2345ce.jpg";